export const idQueryKeys = {
  users: {
    all: (queryKeyParams: { sortBy: string; sortOrder: 'asc' | 'desc' }) => [
      'userManagement',
      queryKeyParams,
    ],
  },
  profile: {
    identities: ['profile', 'identities'] as const,
    moduleMappings: ['profile', 'moduleMappings'] as const,
    organizations: ['profile', 'organizations'] as const,
    supportedConnections: ['profile', 'supportedConnections'] as const,
  },
  organization: {
    create: ['tempoOrganization', 'create'],
  },
  invites: {
    pending: ['invites', 'pending'] as const,
    pendingWithToken: (token: string) => ['invites', 'pending', token] as const,
    accept: (inviteId: number) => ['invites', 'accept', inviteId] as const,
    validate: (inviteToken: string) => ['invites', 'validate', inviteToken] as const,
  },
  subscriptions: ['subscriptions'] as const,
  subscriptionInfo: ['subscriptionInfo'] as const,
  trials: ['trials'] as const,
};
